import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "WarningWidget WarningWidgetPrimary WarningWidgetRow"
}
const _hoisted_2 = { class: "WarningWidgetOuterContentWrapper" }
const _hoisted_3 = { class: "WarningWidgetInnerContentWrapper" }
const _hoisted_4 = {
  key: 1,
  class: "LoadingContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    class: _normalizeClass([
			..._ctx.classes,
			{ 'CampaignEditorLoadingWrapper': _ctx.isLoading }
		])
  }, {
    default: _withCtx(() => [
      (_ctx.hasLoadingFailed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "lnr-info WarningWidgetIcon" }, null, -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.errorMessage), 1 /* TEXT */),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _cache[2] || (_cache[2] = _createTextVNode(" Wait a few moments and try again. ", -1 /* CACHED */))
                ]),
                _createElementVNode("button", {
                  class: "RetryLoadingProcessButton",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retryLoadingProcess && _ctx.retryLoadingProcess(...args)))
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("span", null, "Try again", -1 /* CACHED */),
                  _createElementVNode("i", { class: "lnr-redo2 RetryLoadingProcessButtonIcon" }, null, -1 /* CACHED */)
                ]))])
              ])
            ])
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _renderSlot(_ctx.$slots, "default", { key: 2 })
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class"]))
}